import { useMemo } from "react";
import { ChevronLeft, ChevronRight } from "./Icons.jsx";
import { CATEGORY_META } from "./Icons.jsx";
import { toInputValue } from "../lib/dates.js";

const DOW = ["M", "T", "W", "T", "F", "S", "S"];

/**
 * Month grid. `entriesByDay` maps yyyy-mm-dd to the entries written that day,
 * which drives the per-day markers.
 */
export function MiniCalendar({ month, onMonth, selected, onSelect, entriesByDay, compact = false }) {
  const days = useMemo(() => {
    const first = new Date(month.getFullYear(), month.getMonth(), 1);
    // Monday-first grid.
    const offset = (first.getDay() + 6) % 7;
    const start = new Date(first);
    start.setDate(start.getDate() - offset);

    return Array.from({ length: 42 }, (_, i) => {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      return d;
    });
  }, [month]);

  const todayKey = toInputValue(new Date());
  const shift = (delta) => onMonth(new Date(month.getFullYear(), month.getMonth() + delta, 1));

  return (
    <div className="cal">
      <div className="cal-head">
        <button className="icon-btn" onClick={() => shift(-1)} aria-label="Previous month">
          <ChevronLeft size={16} />
        </button>
        <div className="month">
          {month.toLocaleDateString(undefined, { month: "long", year: "numeric" })}
        </div>
        <button className="btn btn-ghost btn-sm" onClick={() => {
          const now = new Date();
          onMonth(new Date(now.getFullYear(), now.getMonth(), 1));
          onSelect?.(toInputValue(now));
        }}>
          Today
        </button>
        <button className="icon-btn" onClick={() => shift(1)} aria-label="Next month">
          <ChevronRight size={16} />
        </button>
      </div>

      <div className="cal-grid">
        {DOW.map((d, i) => <div className="cal-dow" key={i}>{d}</div>)}

        {days.map((d) => {
          const key = toInputValue(d);
          const dayEntries = entriesByDay[key] || [];
          const cats = [...new Set(dayEntries.map((e) => e.category))].slice(0, 3);
          return (
            <button
              key={key}
              className={[
                "cal-day",
                d.getMonth() !== month.getMonth() ? "outside" : "",
                key === todayKey ? "today" : "",
                key === selected ? "selected" : "",
              ].filter(Boolean).join(" ")}
              onClick={() => onSelect?.(key === selected ? null : key)}
              title={dayEntries.length ? `${dayEntries.length} entr${dayEntries.length === 1 ? "y" : "ies"}` : undefined}
            >
              <span>{d.getDate()}</span>
              <span className="dots">
                {cats.map((c) => (
                  <i key={c} style={{ "--cat": CATEGORY_META[c]?.color || "var(--accent)" }} />
                ))}
              </span>
            </button>
          );
        })}
      </div>

      {!compact && (
        <div className="cal-legend">
          {Object.entries(CATEGORY_META).map(([id, m]) => (
            <span key={id}>
              <i style={{ background: m.color }} /> {m.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
